<template>
    <div class="columns changed-availabilities">
        <div class="column is-12" v-if="availabilities.length > 0">
            <div class="columns is-multiline" v-if="show">
                <div class="column is-12">
                    <button class="button is-info" @click.prevent="show = false">{{ $t('availabilities.intro.changedAvailabilitiesCTA.hide') }}</button>
                </div>
                <div class="column is-12">
                    <div class="notification is-yellow" v-html="$t('availabilities.intro.copy5')"></div>
                </div>

                <div class="column is-12">
                    <table class="table is-bordered changed-availabilities-table" :class="{loading: loading}">
                        <thead>
                            <tr>
                                <th>
                                    <router-link :to="getSortingLink('day')" class="header-content">
                                        <span v-if="ordering !== 'day' && ordering !== '-day'" @click="onSortClicked('day')">
                                            {{ $t('availabilities.detail.date') }}
                                            <i aria-hidden="true" class="fa fa-sort"></i>
                                        </span>
                                        <span v-else class="has-icons" @click="onSortClicked('day')">
                                            <span>{{ $t('availabilities.detail.date') }}</span>
                                            <i aria-hidden="true" class="fa" :class="'fa-sort-' + (ordering === 'day' ? 'desc': 'asc')"></i>
                                        </span>
                                    </router-link>
                                </th>
                                <th>
                                    <router-link :to="getSortingLink('campsite')" class="header-content">
                                        <span v-if="ordering !== 'campsite' && ordering !== '-campsite'" @click="onSortClicked('campsite')">
                                            {{ $t('availabilities.detail.campsite') }}
                                            <i aria-hidden="true" class="fa fa-sort"></i>
                                        </span>
                                        <span v-else class="has-icons" @click="onSortClicked('campsite')">
                                            <span>{{ $t('availabilities.detail.campsite') }}</span>
                                            <i aria-hidden="true" class="fa" :class="'fa-sort-' + (ordering === 'campsite' ? 'desc': 'asc')"></i>
                                        </span>
                                    </router-link>
                                </th>
                                <th class="is-narrow">
                                    {{ $t('campsites.quantity') }}
                                </th>
                                <th class="is-narrow">
                                    {{ $t('availabilities.detail.dailyQuota') }}
                                    <info-i :track="['AvailabilitiesIntro', 'dailyQuota']">{{ $t('availabilities.flyouts.dailyQuota') }}</info-i>
                                </th>
                                <th class="is-narrow">
                                    {{ $t('availabilities.detail.onlineBookings') }}
                                    <info-i :track="['AvailabilitiesIntro', 'bookings']">{{ $t('availabilities.flyouts.bookings') }}</info-i>
                                </th>
                                <th>
                                    {{ $t('availabilities.detail.available') }}
                                    <info-i direction="left" :track="['AvailabilitiesIntro', 'availabilities']">{{ $t('availabilities.flyouts.availabilities') }}</info-i>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="availability of availabilities" @click="redirectToDetail(availability)" @mouseover="availability.expanded = true" @mouseleave="availability.expanded = false">
                                <td class="date">
                                    <span class="weekday">{{ availability.day | localizedDate($t('generic.calendar.dateformatMomentjsWeekday')) }}</span>
                                    <span class="date">{{ availability.day | localizedDate($t('generic.calendar.dateformatMomentjsLong')) }}</span>
                                </td>
                                <td>
                                    <span v-if="availability.campsiteName.length <= 32">{{ availability.campsiteName }}</span>
                                    <span v-else class="name-wrapper">
                                        <span class="full-name" v-if="availability.expanded">{{ availability.campsiteName }}</span>
                                        <span class="short-name" v-else>{{ availability.campsiteName | truncate(32) }}</span>
                                    </span>
                                </td>
                                <td>{{ availability.quantity }}</td>
                                <td>{{ availability.availability }}</td>
                                <td>{{ availability.bookings }}</td>
                                <td class="result">
                                    <div class="result-inner">
                                        <span class="result-number">{{ availability.result }}</span>
                                        <span class="battery-wrapper">
                                            <battery v-model="availability.percent" v-if="!loading" :isSmall="true"></battery>
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="column is-12">
                    <div class="columns">
                        <div class="column is-clearfix">
                            <pagination :loading="loading" :params="this.$route.query" :currentPage="Number(this.page)" :limit="pageSize" :numPages="numPages">
                                <label>{{ $t('generic.page') }}: </label>
                            </pagination>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns" v-else>
                <div class="column is-12">
                    <button class="button is-info" @click.prevent="show = true">{{ $t('availabilities.intro.changedAvailabilitiesCTA.show') }}</button>
                </div>
            </div>
        </div>
        <div class="column is-12" v-else>
            <div class="notification is-yellow" v-if="!loading">
                {{ $t('availabilities.intro.noChangedAvailabilites') }}
            </div>
        </div>
    </div>
</template>

<script>
    import { AppModel } from '../../../models';
    import { Api } from '../../../api';
    import { Tracking } from '../../../utils';
    import { Pagination } from '../../components';
    import InfoI from '../../components/availabilities/info-i';
    import Battery from '../../components/availabilities/battery';
    import AvailabilitiesCampsiteAndDateFilter from '../../components/availabilities/availabilities-campsite-and-date-filter';
    import filters from '../../../filters';

    export default {
        name: 'changed-availabilities',

        components: {
            Pagination,
            InfoI,
            Battery,
            AvailabilitiesCampsiteAndDateFilter,
        },

        props: {
            page: {
                type: Number,
                'default': 1,
            },
            ordering: {
                type: String,
                'default': 'day',
            },
            campsites: {
                type: Array,
                'default': () => ([]),
            },
            campsite: {
                type: [Number, String],
                'default': () => (null),
            },
            dateFrom: {
                type: String,
                'default': () => (null),
            },
            dateUntil: {
                type: String,
                'default': () => (null),
            }
        },
        filters: filters,

        data() {
            return {
                pageSize: 20,
                numPages: 1,
                loading: true,
                availabilities: [],
                show: false,
            };
        },

        computed: {
            lang() {
                return AppModel.lang;
            },
        },

        created() {
            this.fetchPage();
        },

        watch: {
            page() {
                this.fetchPage(true);
            },
            ordering() {
                this.fetchPage();
            },
            campsite() {
                this.fetchPage();
            },
            dateFrom() {
                this.fetchPage();
            },
            dateUntil() {
                this.fetchPage();
            },
        },

        methods: {
            fetchPage(scroll = false) {
                let scrollIntvl = null;
                if(scroll) {
                    window.scrollTo(0, 999999);
                    scrollIntvl = setInterval(() => {
                        window.scrollTo(0, 999999);
                    }, 0);
                    setTimeout(() => {
                        clearInterval(scrollIntvl);
                    }, 1000);
                }
                this.loading = true;
                let filters = {};
                if(this.campsite !== null && this.campsite !== undefined) {
                    filters['campsite'] = this.campsite;
                }
                if(this.dateFrom !== null && this.dateFrom !== undefined) {
                    filters['date_from'] = this.dateFrom;
                }
                if(this.dateUntil !== null && this.dateUntil !== undefined) {
                    filters['date_until'] = this.dateUntil;
                }
                Api.availabilities.fetchChangedAvailabilities(this.page, this.ordering, filters).then((response) => {
                    this.numPages = Math.ceil(response.body.count / this.pageSize);
                    this.availabilities = response.body.results.map(a => {
                        a.campsiteName = this.getCampsiteById(a.campsite).name;
                        a.result = Math.max(0, a.availability - a.bookings);
                        a.percent = Math.round(a.result * 10000.0 / Math.max(a.quantity, a.availability)) / 100;
                        a.expanded = false;
                        return a;
                    });
                    this.loading = false;
                    clearInterval(scrollIntvl);
                });
            },

            getCampsiteById(id) {
                for(let campsite of this.campsites) {
                    if(campsite.id === id) {
                        return campsite;
                    }
                }
                return null;
            },

            redirectToDetail(availability) {
                Tracking.trackEvent('AvailabilitiesIntro', 'rowClicked');
                this.$router.push({
                    name: 'availabilities-by-campsite',
                    params: { campsiteId: availability.campsite },
                    query: { date_from: availability.day, date_until: availability.day }
                });
            },
            getSortingLink(field) {
                const antiField = `-${field}`;
                let newOrdering;
                if(field === this.ordering) {
                    newOrdering = antiField;
                } else {
                    newOrdering = field;
                }
                let query = Object.assign({}, this.$route.query, {ordering: newOrdering});
                let params = this.$route.params;
                if(!params.lang) {
                    params.lang = this.lang;
                }
                return {
                    name: this.$route.name,
                    params: params,
                    query: query,
                };
            },

            onSortClicked(field) {
                const lnk = this.getSortingLink(field);
                Tracking.trackEvent('AvailabilitiesIntro', 'sort', lnk.query.ordering);
            },

            onNewRouteRequestedFromFilter(data) {
                this.$router.push(data.route);
            },
        }
    };
</script>

<style lang="scss">
    @import './changed-availabilities.scss';
</style>



// WEBPACK FOOTER //
// src/views/components/availabilities/changed-availabilities.vue